import { Grid, Typography, useMediaQuery, useTheme, Box, GridDirection } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import React from 'react';
import { GetInvoiceFormRowTitleFlex } from '../util';

interface ContentFieldProps {
  title: string;
  content: string | React.ReactElement;
  gridContainerSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  direction?: any;
}

const ContentField: React.FC<ContentFieldProps> = ({ title, content, gridContainerSx = {}, titleSx = {}, contentSx = {}, direction = 'row' }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid container direction={direction} sx={{ width: '100%', flexWrap: 'nowrap', ...gridContainerSx }}>
      <Typography variant='body1' noWrap sx={{ color: 'var(--secondary)', flex: GetInvoiceFormRowTitleFlex(isSmallScreen), ...titleSx }}>{title}</Typography>
      {React.isValidElement(content)
        ? content
        : <Typography variant='body1' noWrap sx={{ color: 'var(--dark)', flex: 1, display: 'flex' }}>{content}</Typography>}
    </Grid>
  );
};

export default ContentField;